import definition from './errors.service';

/**
 * ErrorsService settings
 * @type {{name: string, definition: ErrorsService}}
 */
const Service = {
    name: 'ErrorsService',
    definition
};

export {
    Service
};



// WEBPACK FOOTER //
// ./app/services/errors/index.js